<template>
  <div class="service-notifications">
    <template v-if="serviceNotifications.length">
      <Notification
        v-for="item in serviceNotifications"
        :key="item.id"
        class="service-notifications__item"
        icon="warning-border--no-color"
        modify="_flex _documents"
      >
        <span
          v-html="locale === 'en' ? item.message_eng : item.message_rus"
        ></span>
      </Notification>
    </template>

    <template
      v-if="
        exhibition?.location?.features?.some(f => f.name === 'service_info')
      "
    >
      <Notification
        class="service-notifications__item"
        icon="warning-border--no-color"
        modify="_flex _documents"
      >
        <span
          v-html="getLocaleValue(exhibition, 'service_info')"
          class="event-popular-services__description"
        >
        </span>
      </Notification>
    </template>
  </div>
</template>

<script>
import { Notification } from "@v2/shared/ui/components";
import { mapGetters } from "vuex";
import { getLocaleValue } from "@/helpers/common";
import { i18n } from "@v2/shared/config";

export default {
  name: "ServiceNotificationsBlock",
  components: {
    Notification
  },
  computed: {
    ...mapGetters("event", ["exhibition", "notificationsByPlace"]),
    serviceNotifications() {
      return this.notificationsByPlace("services");
    },
    locale() {
      return i18n.locale;
    }
  },
  methods: {
    getLocaleValue
  }
};
</script>

<style lang="scss" scoped>
.service-notifications {
  display: contents;

  &__item {
    display: flex;
    margin-bottom: 10px;
    width: 100%;
  }
}
</style>
